import {AppSettings, SetAppSettingsAction} from '../types/types'
import { actionTypes } from '../types/enums';

const initialAppSettingsState:AppSettings = {       
        // dssUrl:"",
        webViewerServer: "",
        pdfTronLic: "",
        ertms: {class: -1, type: -1},
        retteflyt: {class: -1, type: -1},
        validFileTypes: "",
        requiredGroups: "",
        apimSubKey: ""
  };

export const appSettings = (state:AppSettings = initialAppSettingsState, action:SetAppSettingsAction):AppSettings => {
          const { type, payload } = action;
              switch (type) {
                  case actionTypes.SET_APP_SETINGS:
                        return payload;
                  default:
                      return state;
              }
  };

  